import { Routes } from '@angular/router';

import { EmptyComponent } from '../empty/empty.component';

export const routes: Routes = [
    {
        path: 'new',
        children: [
            {
                path: 'vna',
                loadChildren: () => import('@se/modules.vna.dashboard').then((m) => m.VNADashboardModule),
            },
            {
                path: 'vnext',
                children: [
                    {
                        path: 'cardio-visit',
                        loadChildren: () => import('@se/modules.cardiology.visit').then((m) => m.CardiologyVisitModule),
                    },
                    {
                        path: 'specialty-reporting',
                        loadChildren: () => import('@se/modules.specialty.reporting').then((m) => m.SpecialtyReportingModule),
                    },
                    {
                        path: 'cp',
                        loadChildren: () => import('@se/modules.custompages').then((m) => m.SeCustompagesModule),
                    },
                    {
                        path: 'ecg',
                        loadChildren: () =>
                            import('@se/modules.cardiology.ecgreporting').then((m) => m.CardiologyEcgReportingModule),
                    },
                    {
                        path: 'mps',
                        loadChildren: () => import('@se/modules.mps').then((m) => m.MpsModule),
                    },
                    {
                        path: 'collaboration',
                        loadChildren: () => import('@se/modules.collaboration').then((m) => m.CollaborationModule),
                    },
                    {
                        path: 'tool',
                        loadChildren: () => import('@se/modules.toolupload').then((m) => m.TooluploadModule),
                    },
                    {
                        path: 'telemonitoring',
                        loadChildren: () => import('@se/modules.telemonitoring').then((m) => m.TelemonitoringModule),
                    },
                    {
                        path: 'third-part-waiting',
                        data: {
                            message: 'ThirdPartsWaitingForOps',
                        },
                        component: EmptyComponent,
                    },
                    {
                        path: 'nre',
                        loadChildren: () => import('@se/modules.nre').then((m) => m.NreModule),
                    },
                    {
                        path: 'teleconsultation',
                        loadChildren: () =>
                            import('@se/modules.teleconsultation').then((m) => m.TeleconsultationModule),
                    },
                    {
                        path: 'administrative',
                        loadChildren: () => import('@se/modules.administrative.pages').then((m) => m.ApModule),
                    },
                ],
            },
        ],
    },
    {
        path: '**',
        component: EmptyComponent,
        pathMatch: 'full',
    },
];
